import { type IAnalyticEventsConfig } from "@magnit/analytic-events/src/manager";

const eventsFooter: IAnalyticEventsConfig = {
  "Footer:Socials:View": {
    ya: {
      eventName: "socials_view",
      block: "socials",
    },
  },
  "Footer:Socials:Ok:Click": {
    ya: {
      eventName: "socials_ok_click",
      block: "socials",
      element: "ok",
    },
  },
  "Footer:Socials:Vk:Click": {
    ya: {
      eventName: "socials_vk_click",
      block: "socials",
      element: "vk",
    },
  },
  "Footer:Socials:Tg:Click": {
    ya: {
      eventName: "socials_tg_click",
      block: "socials",
      element: "tg",
    },
  },
  "Footer:Feedback:View": {
    ya: {
      eventName: "feedback_view",
      block: "feedback",
    },
  },
  "Footer:Feedback:Form:Click": {
    ya: {
      eventName: "feedback_form_click",
      block: "feedback",
      element: "form",
    },
  },
  "Footer:Feedback:Phone:Click": {
    ya: {
      eventName: "feedback_number_click",
      block: "feedback",
      element: "number",
    },
  },
  "Footer:Links:View": {
    ya: {
      eventName: "footerLinks_view",
      block: "footerLinks",
    },
  },
  "Footer:Links:More:Click": {
    ya: {
      eventName: "footerLinks_more_click",
      block: "footerLinks",
      element: "more",
    },
  },
  "Footer:Links:Item:Click": {
    ya: {
      eventName: "footerLinks_item_click",
      block: "footerLinks",
      element: "item",
    },
  },
  "Footer:ToProfile:View": {
    ya: {
      eventName: "toProfile_view",
      block: "toProfile",
    },
  },
  "Footer:ToProfile:ToWeb:Click": {
    ya: {
      eventName: "toProfile_toWeb_click",
      block: "toProfile",
      element: "toWeb",
    },
  },
  "Footer:ToProfile:ToApp:Click": {
    ya: {
      eventName: "toProfile_toApp_click",
      block: "toProfile",
      element: "toApp",
    },
  },
  "Footer:Security:View": {
    ya: {
      eventName: "security_view",
      block: "security",
    },
  },
  "Footer:Security:Click": {
    ya: {
      eventName: "security_fillForm_click",
      block: "security",
      element: "fillForm",
    },
  },
};
export default eventsFooter;
